/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum InputCriteriaDateCodeEnum {
    GREATER_OR_EQUAL = 'GREATER_OR_EQUAL',
    LESS_OR_EQUAL = 'LESS_OR_EQUAL',
    BETWEEN_INTERVAL = 'BETWEEN_INTERVAL'
}
